<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :disabled="disabled"
      :isVc="isVc"
      @reload="reload"
      @checkbox-change="(rows) => (checkedRows = rows)"
      @approved="
        ({ amzReplenishmentDetailCode: code }) => submitApproved([code])
      "
      @rejected="rejected"
    >
      <page-header
        ref="header"
        slot="header"
        :disabled="disabled"
        :isVc="isVc"
        @query="getData"
        @reset="resetPage"
      >
        <el-badge
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="submit-button ml-2"
          :class="{ clearable: !!checkedRowCount }"
          v-if="!disabled"
        >
          <b-button
            size="sm"
            variant="outline-success"
            @click="approved"
            :disabled="!checkedRowCount"
          >
            {{ $l('INDEX.btn_reviewApproved') || '审核通过' }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>
      </page-header>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <SkuRejected
      :visible.sync="skuRejectedOptions.visible"
      :amzReplenishmentDetailCode="skuRejectedOptions.code"
      @reload="reload"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import SkuRejected from '../sku-rejected'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader, SkuRejected },
  props: {
    disabled: { type: Boolean, default: false },
    amzReplenishmentCode: { type: String, default: '' },
    isVc: { type: String, default: '' },
  },
  data() {
    return {
      usePage: true,
      checkedRows: [],
      skuRejectedOptions: { visible: false, code: '' },
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzReplenishmentDetailListApi({
          ...form,
          ...this.page,
          amzReplenishmentCode: this.amzReplenishmentCode,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
          this.clearCheckboxRow()
        })
        .catch(() => {
          this.loading = false
        })
    },
    approved() {
      if (!this.checkedRowCount) {
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_select_data') || '请选择数据',
          type: 'warning',
        })
        return
      }
      const listCode = this.checkedRows.map((item) => {
        return item.amzReplenishmentDetailCode
      })
      this.submitApproved(listCode)
    },
    submitApproved(listCode) {
      this.$confirm(
        this.$l('tips_approved') || '是否要进行审核通过操作？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .ecomAmzReplenishmentDetailApprovedApi({ listCode })
          .catch(() => null)
        this.loadingClose()
        if (!res) return
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_audit_success') || '审核成功！',
          type: 'success',
        })
        this.reload()
        this.clearCheckboxRow()
      })
    },
    rejected({ amzReplenishmentDetailCode: code }) {
      this.skuRejectedOptions = { visible: true, code }
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRows()
    },
  },
}
</script>
<style lang="scss" scoped>
.submit-button {
  .el-icon-circle-close {
    display: none;
  }
}
.submit-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
